/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IAuditFilterState } from "../types";
import { Dayjs } from "dayjs";

export const setSelectedUserNameAction = (state: IAuditFilterState, action: PayloadAction<string>) => {
  state.selectedUserName = action.payload;
};
export const setSelectedAuditStatusAction = (state: IAuditFilterState, action: PayloadAction<string>) => {
  state.selectedAuditStatus = action.payload;
};

export const setSelectedFromDateAction = (state: IAuditFilterState, action: PayloadAction<Dayjs | null | undefined>) => {
  state.selectedFromDate = action.payload;
};
export const setSelectedToDateAction = (state: IAuditFilterState, action: PayloadAction<Dayjs | null | undefined>) => {
  state.selectedToDate = action.payload;
};

export const resetAuditFiltersAction = (state: IAuditFilterState) => {
  state.selectedUserName = "";
  state.selectedAuditStatus = "";
  state.selectedFromDate = null;
  state.selectedToDate = null;
};
